export const imageKitConfig = {
    baseUrl: process.env.REACT_APP_IK_BASE_URL || 'https://ik.imagekit.io/revl',
}